// extracted by mini-css-extract-plugin
export var askAiIcon = "_l2-9";
export var container = "_l2-0";
export var groupSeparator = "_l2-a";
export var highlight = "_l2-4";
export var resultIcon = "_l2-5";
export var resultItem = "_l2-7";
export var resultSubtitle = "_l2-3";
export var resultTitle = "_l2-2";
export var resultsList = "_l2-1";
export var searchGroup = "_l2-6";
export var selected = "_l2-8";